import React from 'react';
const ClearNumberConfig = {
	settings: {
		layout: {}
	},
	routes: [
		{
			path: '/apps/clear-number',
			component: React.lazy(() => import('./ClearNumber'))
		},
	]
};

export default ClearNumberConfig;
